
































































































import {Component, Vue} from 'vue-property-decorator'
import {$} from '@/facade'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import {NeoHelper} from '@/helpers/NeoHelper'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import {OrbitUnpauseStep} from '@/enums/OrbitUnpauseStep'

@Component({
  computed: {
    OrbitUnpauseStep() {
      return OrbitUnpauseStep
    },
  },
  components: {
    OrbitSuccessStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitPauseModal extends Vue {
  currentStep: OrbitUnpauseStep = OrbitUnpauseStep.WAITING_SIGNATURE
  transactionHash: string | null = null

  mounted() {
    this.unpauseOrbit()
  }

  async unpauseOrbit() {
    try {
      const n3InvocationBuilder = getN3InvocationBuilder()
      const unpauseOrbitRoundInvocationBuilder = n3InvocationBuilder.unpauseOrbitInvocation()

      this.transactionHash = await $.walletAdapter.invokeN3Wallet(
        unpauseOrbitRoundInvocationBuilder
      )
      if (!this.transactionHash) throw new Error('Undefined transaction')

      this.currentStep = OrbitUnpauseStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )
      if (!isTransactionValid) throw new Error('Failed to verify transaction')

      this.currentStep = OrbitUnpauseStep.UNPAUSED

      $.toast.success('system.success.persist')
    } catch (error) {
      this.threatError(error)
    }

    this.closeModal()
  }

  closeModal() {
    if (
      this.currentStep === OrbitUnpauseStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitUnpauseStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.currentStep = OrbitUnpauseStep.WAITING_SIGNATURE
    this.$emit('close')
  }

  private threatError(error: any) {
    console.error(error)

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitUnpauseStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitUnpauseStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitUnpauseStep.UNKNOWN_ERROR
  }
}
